"use client";
import React, { useEffect, useState } from "react";
import api from "../../services/api";

const Transactions = () => {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchTransactions = async () => {
        try {
            const { data } = await api.get("/payment/admin/all/transactions");
            setTransactions(data.data || []);
        } catch (err) {
            console.error("Error fetching transactions", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTransactions();
    }, []);

    const getStatusBadge = (status) => {
        switch (status) {
            case "success":
                return "badge bg-success";
            case "pending":
                return "badge bg-warning text-dark";
            case "failed":
                return "badge bg-danger";
            default:
                return "badge bg-secondary";
        }
    };

    return (
        <div className="container my-4">
            <div className="card shadow-lg border-0 rounded-4">

                {/* Header */}
                <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
                    <h5 className="mb-0 text-white">💳Plan Transactions</h5>
                </div>

                {/* Body */}
                <div className="card-body">

                    {/* Loading */}
                    {loading && (
                        <div className="text-center py-4">
                            <div className="spinner-border text-primary"></div>
                        </div>
                    )}

                    {/* Empty */}
                    {!loading && transactions.length === 0 && (
                        <div className="text-center text-muted py-4">
                            No transactions found
                        </div>
                    )}

                    {/* Table */}
                    {!loading && transactions.length > 0 && (
                        <div className="table-responsive">
                            <table className="table table-hover align-middle">

                                <thead className="table-light">
                                    <tr>
                                        <th>#</th>
                                        <th>Plan</th>
                                        <th>User</th>
                                        <th>Amount</th>
                                        <th>Status</th>
                                        <th>Payment ID</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {transactions.map((tx, index) => (
                                        <tr key={tx._id}>
                                            <td>{index + 1}</td>

                                            <td>
                                                <strong>{tx.planId?.name}</strong>
                                            </td>

                                            <td>
                                                <strong>{tx.userId?.fullName}</strong>
                                                <br/>
                                                <span style={{ fontSize: 12, color: "gray" }}>{tx.userId?.email}</span>
                                            </td>

                                            <td>₹{tx.amount}</td>



                                            <td>
                                                <span className={getStatusBadge(tx.status)}>
                                                    {tx.status}
                                                </span>
                                            </td>

                                            <td>
                                                <small className="text-muted">
                                                    {tx.paymentId || "-"}
                                                </small>
                                            </td>

                                            <td>
                                                {new Date(tx.createdAt).toLocaleDateString()}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>

                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Transactions;